import React, { useEffect, useState } from 'react'
import { LanguageCode } from './types'
import {
  getLangCodeForNode,
  getXRefLanguageForNode,
} from '../nodeCrossAssociation/utility'
import { retrieveIds, updateTreeNode } from '../TreeRequests'
import { Box, Button } from '@mui/material'
import {
  NodeLanguageAttribute,
  NodeLanguageSelect,
} from './NodeLanguageAttribute'
import { useGetTreeById } from '../../../reducers/trees_hooks'
import { nodeForId } from '../../utility/TreeHelpers'

export function NodeEditLang({
  treeId,
  versionId,
  nodeId,
}: {
  treeId: string
  versionId: string
  nodeId: string
}) {
  const [editing, setEditing] = useState(false)
  const { tree, resetTree } = useGetTreeById({ treeId, versionId })
  const node = tree && nodeForId(nodeId, tree)

  const [selectedLanguage, setSelectedLanguage] = useState<LanguageCode>('en')
  const [xRefLang, setXRefLang] = useState<string | undefined>(undefined)

  useEffect(() => {
    if (!editing) return
    if (!node || !tree) {
      setSelectedLanguage('en')
      return
    }
    const lang = getLangCodeForNode(node.id, tree) ?? node.body?.lang ?? 'en'
    setSelectedLanguage(lang)
  }, [node, tree, editing])

  useEffect(() => {
    if (!editing) return
    if (!node || !tree) {
      setXRefLang(undefined)
      return
    }
    setXRefLang(getXRefLanguageForNode(node.id, tree))
  }, [node, tree, editing])

  if (!node) return null

  if (!editing) {
    return (
      <Box>
        <Button onClick={() => setEditing(true)}>Edit Language</Button>
      </Box>
    )
  }

  const updateNode = async (lang: LanguageCode) => {
    await updateTreeNode({
      ...retrieveIds(node),
      body: {
        ...node.body,
        lang,
      },
    })
    resetTree?.()
  }

  return (
    <Box padding="10px">
      <Box>
        This Node:{' '}
        <NodeLanguageSelect
          currentValue={node.body?.lang ?? ''}
          onChange={updateNode}
        />
      </Box>
      <Box padding="10px" border="solid 1px">
        {xRefLang && (
          <Box>
            This Node is in a cross ref branch with Language: {xRefLang}
          </Box>
        )}
        <Box>Nodes Below</Box>
        <NodeLanguageSelect
          disabled={!!xRefLang}
          currentValue={selectedLanguage}
          onChange={setSelectedLanguage}
        />
        <NodeLanguageAttribute
          treeId={node.tree_id}
          versionId={node.version}
          branches={[{ nodeId: node.id, languageCode: selectedLanguage }]}
        />
      </Box>
    </Box>
  )
}
